import { BonusType } from '@superbet-group/web.types';
import { Ref } from '@vue/composition-api';

import { BonusConditions } from '@core/models/bonus/BonusConditions';
import { BonusSubtype } from '@core/models/bonus/BonusSubtype';
import { BonusKind } from '@core/models/bonus/Bonus';

export const MAX_DESCRIPTION_ITEMS_NUMBER = 3;

export interface BonusDetailsItem {
    key: BonusFieldKey;
    text: string;
    value: string | number;
    isCurrencyVisible?: boolean;
}

export const BonusFieldKey = {
    PendingAmount: 'PendingAmount',
    AvailableBonusAmount: 'AvailableBonusAmount',
    AvailableFreeSpins: 'AvailableFreeSpins',
    AwardedFreeSpins: 'AwardedFreeSpins',
    BonusAmountUsed: 'BonusAmountUsed',
    BonusAmountGained: 'BonusAmountGained',
    AmountWon: 'AmountWon',
    PotentialWin: 'PotentialWin',
    InitialAmount: 'InitialAmount',
    AwardedBingoTickets: 'AwardedBingoTickets',
    DateReceived: 'DateReceived',
    DateCompleted: 'DateCompleted',
};
export type BonusFieldKey = typeof BonusFieldKey[keyof typeof BonusFieldKey];

export type BonusDetailData = {
    kind: BonusKind;
    type: BonusType;
    amountLeft: number;
    bonusUsedAmount: number;
    redeemedAmount: number;
    bonusAwarded: number;
    bonusPotentialWin: number;
    pendingAmount: number;
    bonusGainedAmount: number;
};

export type BonusStatusDetail = {
    label: string;
    statusText: string;
    description: string;
    style: 'brand' | 'neutral' | 'danger' | 'success';
    iconClass?: string;
};

export type BonusHistoryDetailData = {
    text: string;
    value?: string;
    isCurrency?: boolean;
    class?: string;
    isTerms?: boolean;
};

export const BonusRequirementKey = {
    OfferDetails: 'OfferDetails',
    SportEvents: 'SportEvents',
    CasinoGames: 'CasinoGames',
    WageringRequrement: 'WageringRequrement',
    FreeSpinUsage: 'FreeSpinUsage',
    MinEventOdd: 'MinEventOdd',
    MinTotalOdd: 'MinTotalOdd',
    BonusEventType: 'BonusEventType',
    BonusTicketType: 'BonusTicketType',
    BetsMustSettle: 'BetsMustSettle',
    ExpirationDate: 'ExpirationDate',
} as const;
export type BonusRequirementKey = typeof BonusRequirementKey[keyof typeof BonusRequirementKey];

export type BonusRequirement = {
    key: BonusRequirementKey;
    text: string;
    condition?: string | number;
    isCurrency?: boolean;
    isInfoIconVisible?: boolean;
    bonusAdditionalInfo?: string;
    route?: string;
};

export type BonusRequirementParams = {
    bonusConditions: BonusConditions;
    expirationDate?: Date;
    wageringRequirements: number;
    type: BonusType;
    bonusSubtype: BonusSubtype;
    termsAndConditions?: string;
    offerDetails?: string;
};

export type BonusAwardedParams = {
    bonusItemsAwarded: Ref<number>;
    bonusAwarded: Ref<number>;
    bonusPotentialWin: Ref<number>;
    type: Ref<BonusType>;
    bonusSubtype: Ref<BonusSubtype>;
    isBonusOnHold: Ref<boolean>;
};
